<template>
  <div class="hotchartRoot">
    <div class="title">
      数据更新时间： <span style="color:yellow">{{ lastUpdateTime }}</span>
    </div>
    <div class="hotchart" ref="hotchart">
      <div class="layer" v-for="layer in layers">
        <div class="layer-index">{{ layers - layer + 1 }}</div>
        <div class="sequence" @click="handleSensorClick(layers - layer + 1, sequence)"  v-for="sequence in sequences"
          :class="{ 'level1': sensorData.transformed[layers - layer + 1][sequence] < 5, 'level2': sensorData.transformed[layers - layer + 1][sequence] >=5 && sensorData.transformed[layers - layer + 1][sequence] < 10, 'level3': sensorData.transformed[layers - layer + 1][sequence] >=10 && sensorData.transformed[layers - layer + 1][sequence] < 15, 'level4': sensorData.transformed[layers - layer + 1][sequence] >=15 && sensorData.transformed[layers - layer + 1][sequence] < 20, 'level5': sensorData.transformed[layers - layer + 1][sequence] >=20, 'hidden': sensorData.transformed[layers - layer + 1][sequence] == null }">
          <div class="sequence-label">{{ sensorData.transformed[layers - layer + 1][sequence] }}</div>
        </div>
      </div>
      <div class="layer">
        <div class="layer-index"> </div>
        <div class="layer-header" v-for="sequence in sequences">
          <div class="sequence-label">{{ sequence }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/api';
import * as moment from 'moment';
export default {
  name: 'HotChart',
  data() {
    return {
      intervalId: null,
      lastUpdateTime: '-',
      layers: 0,
      sequences: 0,
      sensorData: [],
      responseData: [],
      chart: null,
      option: {}
    }
  },
  methods: {
    handleSensorClick(layer, sequence) {
      const that = this;
      const filtered = that.responseData.filter(d => 
        d.sequence_index == sequence &&
        d.layer_index ==layer
      )
      console.log("FILTERED", layer, sequence, filtered)
      if(filtered.length == 1) {
        that.$emit('sensor-click', {
          device_id: filtered[0].device_id,
          channel_id: filtered[0].channel_id
        })
      }
    },
    clearSegmentId() {
      this.segmentId = null;
    },
    setSegmentId(segmentId) {
      this.segmentId = segmentId;
      this.refresh();
    },
    refresh() {
      this.createData();
    },
    createData() {
      function range(from, to) {
        const arr = [];
        for (let i = from; i < to; i++) {
          arr.push(i);
        }
        return arr;
      }
      function transformData(data) {
        let maxLayerIndex = 0;
        let maxSequenceIndex = 0;
        let maxTime = 0;

        const transformed = data.reduce((accumulator, current) => {
          // 更新最大的layer_index和sequence_index
          if (current.layer_index > maxLayerIndex) {
            maxLayerIndex = current.layer_index;
          }
          if (current.sequence_index > maxSequenceIndex) {
            maxSequenceIndex = current.sequence_index;
          }

          if (moment(current.time).valueOf() > maxTime) {
            maxTime = moment(current.time).valueOf();
          }

          // 如果accumulator中还没有当前layer_index的对象，则创建一个
          if (!accumulator[current.layer_index]) {
            accumulator[current.layer_index] = {};
          }

          // 在对应的layer_index对象中，设置sequence_index对应的percentage_difference
          accumulator[current.layer_index][current.sequence_index] = (current.percentage_difference != null) ? parseInt(current.percentage_difference) : null;

          // 返回累加器，用于下一次迭代
          return accumulator;
        }, {}); // 初始值为空对象

        // 返回最大layer_index，最大sequence_index和转换后的数据
        return {
          maxLayerIndex,
          maxSequenceIndex,
          transformed,
          maxTime
        };
      }

      const that = this;
      let data = [];
      let index = [];
      let levels = [];
      const segmentId = this.segmentId;
      if (segmentId === null) {

      } else {
        api.get(`/segments/${segmentId}/sensorState`).then(response => {
          const sensorState = response.data.data;
          that.responseData = sensorState;
          console.log('hotChart sensorState', moment().format('YYYY-MM-DD HH:mm:ss'), sensorState);
          that.sensorData = transformData(sensorState);
          const maxSequenceIndex = that.sensorData.maxSequenceIndex;
          that.sequences = maxSequenceIndex;
          const maxLayerIndex = that.sensorData.maxLayerIndex;
          that.layers = maxLayerIndex;
          that.lastUpdateTime = that.sensorData.maxTime === 0 ? '-' : moment(that.sensorData.maxTime).format('YYYY-MM-DD HH:mm:ss');
        })
      }

    }
  },
  mounted() {
    const that = this;
    that.intervalId = setInterval(() => {
      that.refresh()
    }, 5000)
  },
  beforeDestroy() {
    const that = this;
    if(that.intervalId) {
      clearInterval(that.intervalId)
      that.intervalId = null;
    }
  }
}
</script>

<style lang="less" scoped>
.hotchartRoot {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.hotchartRoot .title {
  font-size: 9px;
  padding: 5px;
}
.hotchart {
  padding-top: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
}

.layer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.layer-header {
  font-size: 9px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layer-index {
  width: 100px;
  height: 100%;
  font-size: 9px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sequence {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
}

.sequence.level1 {
  background-color: rgba(0,128,0,0.8);
}

.sequence.level2 {
  background-color: rgba(0,128,128,0.8);
}

.sequence.level3 {
  background-color: rgba(128,128,0,0.8);
}

.sequence.level4 {
  background-color: rgba(128, 64, 0, 0.8);
}

.sequence.level5 {
  background-color: rgba(128, 0, 0, 0.8);
}

.sequence.red {
  background-color: red;
}

.sequence.hidden {
  background-color: rgba(0, 0, 0, 0);
}

.sequence-label {
  font-size: 9px;
  line-height: 32px;
  text-align: center;
}
</style>
